import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const ApplyCoupon = createAsyncThunk(
  "couponData/applyCoupon",
  async (code, thunkAPI) => {
    try {
  
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("authToken");
      const response = await axios.post(
        endPoint.ApplyCouponApi,
        { couponCode: code },
        {
          headers: {
            sessionId: storedUuid ? storedUuid : "",
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.error("Error Details:", error.response?.data || error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const ApplyCouponSlice = createSlice({
  name: "CouponData",
  initialState: {
    CouponData: [],
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ApplyCoupon.fulfilled, (state, action) => {
        state.CouponData = action.payload;
      })
      .addCase(ApplyCoupon.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ApplyCouponSlice.reducer;
